import React from "react";
import { Card, CardContent, Typography, CircularProgress, Icon } from "@mui/material";
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import { useEffect } from "react";
import { useState } from "react";
import ComponentHeaderTitles from "../ComponentHeaderTitles";
import ListItemIcon from '@mui/material/ListItemIcon';

/**
 * Enum for the chosen product.
 * @readonly
 * @enum {string}
 */


const BACKEND_URL = process.env.BACKEND_URL + "/index_new";


/**
 * A component that allows the user to select a product from a list of options.
 * 
 * 
 * the objecto send looks like this:
 * {
    "energy": {
        "estimate": 0,
        "hasTeruglevering": 0,
        "teruglevering": 0,
        "double_meter": 1,
        "productType": "e",
        "inhuizing": "Nee",
        "usage_e": 0,
        "usage_g": null,
        "usage_e_l": "25",
        "usage_e_h": "25",
        "teruglevering_e": null,
        "teruglevering_e_l": null,
        "teruglevering_e_h": null,
        "date": "2023-11-25T23:00:00.000Z",
        "smart_meter": true
    },
    "personal": {
        "postcode": "9606RH",
        "number": "83",
        "company_name": null,
        "company_coc": null,
        "suffix": null,
        "street": "Tjalk",
        "city": "Kropswolde",
        "firstName": "Reilly",
        "lastName": "Pieterson",
        "email": "reilly@dycon.nl",
        "phone": "0614407748",
        "notes": null,
        "consent": true,
        "gender": "male",
        "birthdate": "25-10-1994",
        "benaderen": "Ja",
        "payment": "Automatische incasso",
        "business": 0,
        "voorschot": "Nee",
        "ik_wil_overstappen_per": "Anders",
        "ingangsdatum": "2023-11-28T23:00:00.000Z",
        "warmtepomp": true,
        "elektrischeautometlaadpaal": true
    },
    "selected": {
        "id": 86019,
        "name": "Dynamisch energie contract Huishoudelijk 3 jaar met flex",
        "identifier": "dynamisch-energie-contract-huishoudelijk-3-jaar-met-flex",
        "supplier_id": 2517,
        "type": "e",
        "usp": "- U ontvangt beursprijzen, uurprijs voor stroom, dagprijs voor gas\r\n- Maandelijks kosteloos opzegbaar\r\n- Je hebt ook de mogelijkheid om een vaste prijs te kiezen\r\n- voor elk contractjaar heb je de mogelijkheid om (een gedeelte van) het energieverbruik in te klikken tegen een vaste prijs.\r\n- Ontvang hiervoor dagelijks aanbiedingen nadat afsluiten van het contract",
        "description": "",
        "business": "0",
        "retention": "2",
        "switchdate_business_min": null,
        "switchdate_business_max": null,
        "switchdate_business_default": null,
        "switchdate_business_min_date": null,
        "switchdate_consumer_min": null,
        "switchdate_consumer_max": null,
        "switchdate_consumer_default": null,
        "switchdate_consumer_min_date": null,
        "valid_from": null,
        "valid_till": null,
        "created_at": "2023-10-20 14:50:44",
        "updated_at": "2023-10-23 11:11:15",
        "supplier_name": "Clean Energy Dynamics",
        "address": {
            "postcode": "9606RH",
            "housenumber": "83",
            "suffix": null,
            "streetname": "Tjalk",
            "city": "Kropswolde"
        },
        "ean_codes": {
            "electricity": [
                {
                    "grid_operator_name": "Enexis B.V.",
                    "grid_operator": 8716871000001,
                    "ean_code": 871694840004809100
                }
            ]
        },
        "cost_specifications": {
            "building_function": 1,
            "electricity": {
                "double_meter": true,
                "has_return": true,
                "expected_dynamic_purchase_cost": 7.5,
                "expected_dynamic_purchase_cost_inc_vat": 9.08,
                "purchase_surcharge_cost": 5,
                "purchase_surcharge_cost_inc_vat": 6.05,
                "usage_low": 25,
                "usage_high": 25,
                "full_usage_high": 25,
                "full_usage_low": 25,
                "full_return_low": 0,
                "full_return_high": 0,
                "return_cash": 0,
                "return_cash_consumer": 0,
                "return_purchase_fee_cost": 0,
                "return_purchase_fee_cost_consumer": 0,
                "delivery_cost": "12,50",
                "delivery_cost_inc_vat": "15,13",
                "government_tax_per_year": "6,30",
                "government_tax_per_month": "0,52",
                "government_tax_per_year_inc_vat": "7,62",
                "government_tax_per_month_inc_vat": "0,64",
                "fixed_delivery_cost": "119,40",
                "fixed_delivery_cost_inc_vat": "144,47",
                "fixed_delivery_cost_return": "0,00",
                "fixed_delivery_cost_return_inc_vat": "0,00",
                "tax_reduction": "493,27",
                "tax_reduction_inc_vat": "596,86",
                "tariff_grid_operator_monthly": "22,44",
                "tariff_grid_operator_year": "269,33",
                "tariff_grid_operator_monthly_inc_vat": "27,16",
                "tariff_grid_operator_year_inc_vat": "325,89",
                "grid_operator_name": "Enexis 3x25A",
                "total": "-85,74",
                "total_inc_vat": "-103,74",
                "total_vat": "-18,00",
                "total_with_price_cap": "-86,03",
                "total_with_price_cap_inc_vat": "-104,10",
                "tariff_energytax_exc_vat": {
                    "0 - 50": "0,12599"
                },
                "total_energytax_exc_vat": {
                    "0 - 50": "6,30"
                },
                "tariff_ode_exc_vat": {
                    "0 - 50": "0,00000"
                },
                "total_ode_exc_vat": {
                    "0 - 50": "0,00"
                },
                "tariff_energytax_inc_vat": {
                    "50": "0,15245"
                },
                "total_energytax_inc_vat": {
                    "50": "7,62"
                },
                "tariff_ode_inc_vat": {
                    "50": "0,00000"
                },
                "total_ode_inc_vat": {
                    "50": "0,00"
                },
                "tariff": {
                    "dynamic_average_tariff": 0.15,
                    "dynamic_average_tariff_inc_vat": 0.1815,
                    "purchase_surcharge_tariff": 0.1,
                    "purchase_surcharge_tariff_inc_vat": 0.121,
                    "return_purchase_fee_tariff": 0.1,
                    "return_purchase_fee_tariff_inc_vat": 0.121,
                    "all_in_tariff_low": "0,37599",
                    "all_in_tariff_low_inc_vat": "0,45495",
                    "all_in_tariff_high": "0,37599",
                    "all_in_tariff_high_inc_vat": "0,45495",
                    "tariff_fixed_fee_month": "9,95",
                    "tariff_fixed_fee_month_inc_vat": "12,04"
                }
            },
            "total": {
                "total": "-85,74",
                "total_inc_vat": "-103,74",
                "total_per_month": "-7,14",
                "total_per_month_inc_vat": "-8,65",
                "total_vat": "-18,00",
                "total_with_price_cap": "-86,03",
                "total_with_price_cap_inc_vat": "-104,10",
                "total_per_month_with_price_cap": "-7,17",
                "total_per_month_with_price_cap_inc_vat": "-8,67"
            }
        }
    },
    "dynamic_contract": 1
}
 *
 * @param {function} setChosenProduct - A function to update the chosen product.
 * @returns {JSX.Element} The ProductKiezer component.
 */
function BestellingAanmaken({
    chosenPakket,
    chosenProduct,
    dubbeleMeter,
    geslacht,
    warmtepomp,
    elektrischeAuto,
    voornaam,
    achternaam,
    geboorteDatum,
    availableMeters,
    chosenUsage,
    returnedEnergyAmount,
    email,
    telefoonnummer,
    chosenEntity,
    kvkNummer,
    bedrijfsnaam,
    overstapDatum,
    setSubmissionSuccessful,
    setSubmissionFailed,
    setSubmissionFailedWithReasons,
    betaalmethode,
    selectedEan = { selectedEan },
    setIsFetchingData,
    agentID
    }) {
    const [fetchingData, setFetchingData] = useState(true);
    const [responseSuccesful, setResponseSuccesful] = useState(null);


    /**
     * Sends data to google tag manager.
     * @param {*} salesID 
     */
    function sendToDataLayer(salesID) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ ecommerce: null });
        window.dataLayer.push({
          event: "purchase",
          ecommerce: {
  
            transaction_id: salesID,
            value: chosenPakket.cost_specifications.total.total_inc_vat,
            items: [
              {
                item_id: chosenPakket.id,
                item_name: chosenPakket.identifier,
                affiliation: chosenPakket.supplier_name,
                item_category: chosenPakket.type,
                item_variant: chosenPakket.identifier,
                price: chosenPakket.cost_specifications.total.total_inc_vat,
                quantity: 1,
                products: chosenProduct.length > 1 ? chosenProduct.join(" & ") : chosenProduct[0]
              }
            ]
          }
        })
    }

    /**
     * Returns an object that can be sent to the API.
     * @returns {Object} An object that can be sent to the API. The object has the following keys:
     * selected, personal, energy, eancodeboek_eans, dynamic_contract
     */
    function make_payload_object() {
        let payload = {
            selected: chosenPakket,
            personal: make_personal_object(),
            energy: make_energy_object(),
            eancodeboek_eans: get_eancodeboek_eans(),
            dynamic_contract: 0,
            agent: agentID
        }
        return payload;

    }

    /**
     * Normalizes the birthdate to the format DD-MM-YYYY, which is required by the API.
     * @returns {string} The normalized birthdate.
     * @example "25-10-1994"
     */
    function normalize_birthdate() {
        const birthdate = new Date(geboorteDatum);
        // Use '2-digit' option for day and month to ensure two digits
        const birthdateOptions = { day: '2-digit', month: '2-digit', year: 'numeric' };
        return birthdate.toLocaleDateString('nl-NL', birthdateOptions);
    }


    /**
     * Loops through the available meters and returns the ean code for the selected product and the specified address.
     * If the user had to manually select an ean code for a product, the selectedEan object will be used.
     * @returns {Object} An object containing the ean codes for the selected product and the specified address.
     * @example { electricity: 8716871000001, gas: 8716871000002}
     * 
     */
    function get_eancodeboek_eans() {
        var eancodeboek_eans = {
            electricity: null,
            gas: null,
        }
        for (let meter of availableMeters) {
            if (meter.address.postalCode == chosenPakket.address.postcode &&
                meter.address.streetNumber == chosenPakket.address.housenumber &&
                (chosenPakket.address.suffix === undefined || meter.address.streetNumberAddition == chosenPakket.address.suffix)) {
                if (meter.product === "ELK") {
                    // check if selectedEan is not null
                    if (selectedEan && selectedEan.RequiredStroomMeterEAN) {
                        eancodeboek_eans.electricity = selectedEan.RequiredStroomMeterEAN;
                    } else {
                        eancodeboek_eans.electricity = meter.ean;
                    }
                }
                if (meter.product === "GAS") {
                    if (selectedEan && selectedEan.RequiredGasMeterEAN) {
                        eancodeboek_eans.gas = selectedEan.RequiredGasMeterEAN;
                    } else {
                        eancodeboek_eans.gas = meter.ean;
                    }
                }
            }
        }
        return eancodeboek_eans;
    }

    function make_personal_object() {
        let personal = {
            postcode: chosenPakket.address.postcode,
            number: chosenPakket.address.housenumber,
            suffix: chosenPakket.address.suffix,
            street: chosenPakket.address.streetname,
            city: chosenPakket.address.city,
            email: email,
            phone: telefoonnummer,
            gender: geslacht === "Dhr" ? "male" : "female",
            firstName: voornaam,
            lastName: achternaam,
            birthdate: normalize_birthdate(),
            notes: null,
            consent: true,
            business: chosenPakket.business,
            // elektrischeautometlaadpaal: elektrischeAuto ? "Ja" : "Nee",
            // warmtepomp: warmtepomp ? "Ja" : "Nee",
            payment: betaalmethode,
            ik_wil_overstappen_per: "Anders",
            ingangsdatum: overstapDatum,
        };

        if (chosenEntity === "Zakelijk") {
            personal.company_name = bedrijfsnaam;
            personal.company_coc = kvkNummer;
        }

        return personal;
    }

    function make_energy_object() {
        let energy = {
            estimate: 0,
            double_meter: dubbeleMeter ? 1 : 0,
            productType: chosenPakket.type,
            inhuizing: "Nee",
            usage_g: chosenPakket.cost_specifications.gas ? chosenPakket.cost_specifications.gas.usage : null,
            // set teruglevering_e_l & teruglevering_e_h to null if dubbeleMeter is not used

            smart_meter: 0, // we don't ask for smart meter
            inhuizing: "Nee",
            voorschot: 'Nee',

        };

        // add usage_e to energy if dubbeleMeter is true, otherwise add usage_e_l and usage_e_h
        if (!dubbeleMeter) {
            energy.usage_e = chosenPakket.cost_specifications.electricity ? chosenPakket.cost_specifications.electricity.full_usage_single : null;
            energy.teruglevering_e = chosenPakket.cost_specifications.electricity ? chosenPakket.cost_specifications.electricity.full_return_single : null;
        } else {
            energy.usage_e_l = chosenPakket.cost_specifications.electricity ? chosenPakket.cost_specifications.electricity.full_usage_low : null;
            energy.usage_e_h = chosenPakket.cost_specifications.electricity ? chosenPakket.cost_specifications.electricity.full_usage_high : null;
            energy.teruglevering_e_l = chosenPakket.cost_specifications.electricity ? chosenPakket.cost_specifications.electricity.full_return_low : null;
            energy.teruglevering_e_h = chosenPakket.cost_specifications.electricity ? chosenPakket.cost_specifications.electricity.full_return_high : null;
        }


        return energy;

    }



    const [errorMessage, setErrorMessage] = useState([]);

    function validate_response(response) {
        // check if 'status' property in response
        var orderDetails = response.sd;
        if (typeof orderDetails !== 'undefined' && 'success' in orderDetails) {
            var orderSuccessful = orderDetails.success;
        } else {
            var orderSuccessful = false;
        }
        if (orderSuccessful) {
            sendToDataLayer(orderDetails.data.sale_id)
            setResponseSuccesful(true);
            setSubmissionSuccessful(); // Inform the parent component of success
        } else {
            if ('sd' in response) {
                const errors = get_salesdock_validation_error_message(orderDetails);
                // Check if errors object is not empty
                if (errors && Object.keys(errors).length > 0) {
                    // Extract error messages from each key and flatten them into an array
                    const errorMessages = [].concat(...Object.values(errors));
                    // Map the error messages to custom error messages
                    const customErrorMessages = errorMessages.map(custom_error_message_to_show_to_user);
                    // remove the false values from the array so that we only show error message to the user
                    // that we are prepared to show.
                    const filteredErrorMessages = customErrorMessages.filter(function (el) {
                        return el != false;
                    });
                    prepareErrorMessageList(filteredErrorMessages);

                } else {
                    prepareErrorMessageList([]); // Pass an empty array if no errors
                }
            } else {
                prepareErrorMessageList([]);
            }
            setResponseSuccesful(false);
        }
    }

    function prepareErrorMessageList(errors) {


        // If there are specific error messages
        if (errors.length > 0) {
            setErrorMessage(errors);
            setSubmissionFailedWithReasons(true); // Inform the parent component that there are specific reasons for failure
            setSubmissionFailed(false); // No generic failure since we have specific reasons
        } else {
            // If there are no specific error messages, set a generic error message
            setErrorMessage(["Er is een onbekende fout opgetreden. Neem contact op met de klantenservice."]);
            setSubmissionFailedWithReasons(false); // Inform the parent component that there are no specific reasons
            setSubmissionFailed(true); // Inform the parent component of a generic failure
        }
    }



    /**
     * Maps the error messages to custom error messages that we want to show to the user.
     * If not found, returns false so that we can filter it out.
     * 
     * @param {*} error 
     * @returns 
     */
    function custom_error_message_to_show_to_user(error) {
        const messagesToShow = {
            "Het KVK-nummer is ongeldig.": "Het KVK-nummer is ongeldig.",
            "You have to fill in a valid phone number.": "Je hebt geen geldig telefoonnummer ingevuld.",
        };

        if (messagesToShow[error]) {
            return messagesToShow[error];
        }
        return false;
    }

    function get_salesdock_validation_error_message(salesdockResponseObject) {
        return salesdockResponseObject.errors;
    }


    function make_request() {
        let payload = make_payload_object();
        fetch(BACKEND_URL, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(payload),
        })
            .then(response => response.json())
            .then(data => {
                validate_response(data);
                setFetchingData(false);
                setIsFetchingData(false);
            })
    }



    // When the component mounts, we call the API to get the products
    useEffect(() => {
        make_request();
    }, []);





    /**
     * We show a spinner when the products are being fetched.
     */
    if (fetchingData) {
        return (
            <div className="spinner-container">
                <CircularProgress className='data-fetch-spinner' />
            </div>
        );
    }

    if (!fetchingData && !responseSuccesful) {
        return (
            <div className="bestelling-aanmaken-error-message">
                <ComponentHeaderTitles
                    title={`Het aanmaken van je bestelling is helaas niet gelukt om de volgende${errorMessage.length === 1 ? ' reden:' : ' redenen:'}`}
                />

                <List component="ul" className="submission-error-list">
                    {errorMessage.map((error, index) => (
                        <ListItem key={index} component="li">
                            <ListItemIcon>
                                {/* You can use a dot or any other symbol as a bullet */}
                                <Typography variant="body1">•</Typography>
                            </ListItemIcon>
                            <ListItemText primary={error} />
                        </ListItem>
                    ))}
                </List>

                <Typography variant="body1" component="p" color="textPrimary">
                    Ga terug in het formulier om je gegevens te corrigeren.
                    Kom je er niet helemaal uit? Neem dan contact op met onze klantenservice.
                </Typography>
            </div>
        );
    }


    return (
        <div class="bestelling-aanmaken-success-message">
            <ComponentHeaderTitles
                title={"Gelukt! Je ontvangt binnenkort een email met je offerte."}
            />
            <Typography variant="body1" component="p" color="textPrimary">
                Je ontvangt binnenkort een email met je offerte. Zie je de email niet in je inbox? Kijk dan in je spam folder of
                neem contact op met onze klantenservice.
            </Typography>
        </div>
    );
}

BestellingAanmaken.displayName = "BestellingAanmaken";
export default BestellingAanmaken;
